import { ReactNode } from "react";
import { WPPost } from "../constants/types";
import {
    LocalInformationPostTypeACF,
    ChallengingSituationsACF,
    ConditionPostTypeACF,
    PopulationPostTypeACF,
} from "../constants/types/acf";

export enum PostTypes {
    Population = "population",
    ChallengingSituation = "situations",
    Condition = "disorder-or-concern",
    LocalInformation = "local-information",
}

export const PostTypesWithLocalServicesBeforeFooter: PostTypes[] = [
    PostTypes.Population,
    PostTypes.ChallengingSituation,
    PostTypes.Condition,
];

type AllPostTypePages = WPPost<
    | PopulationPostTypeACF
    | ConditionPostTypeACF
    | ChallengingSituationsACF
    | LocalInformationPostTypeACF
>;

export const matchPostType = (
    post: AllPostTypePages,
    fns: {
        population: (post: WPPost<PopulationPostTypeACF>) => ReactNode;
        condition: (post: WPPost<ConditionPostTypeACF>) => ReactNode;
        situation: (post: WPPost<ChallengingSituationsACF>) => ReactNode;
        localInformation: (post: WPPost<LocalInformationPostTypeACF>) => ReactNode;
    },
) => {
    switch (getPostType(post)) {
        case PostTypes.Population:
            return fns.population(post as WPPost<PopulationPostTypeACF>);
        case PostTypes.Condition:
            return fns.condition(post as WPPost<ConditionPostTypeACF>);
        case PostTypes.ChallengingSituation:
            return fns.situation(post as WPPost<ChallengingSituationsACF>);
        case PostTypes.LocalInformation:
            return fns.localInformation(post as WPPost<LocalInformationPostTypeACF>);
    }
};

export const PostTypeMatchers = {
    isPopulation: (post: AllPostTypePages): post is WPPost<PopulationPostTypeACF> => {
        return post.type === "population";
    },
    isChalleningSituation: (post: AllPostTypePages): post is WPPost<ChallengingSituationsACF> => {
        return post.type === "situations";
    },
    isCondition: (post: AllPostTypePages): post is WPPost<ConditionPostTypeACF> => {
        return post.type === "condition";
    },
    isLocalInformation: (post: AllPostTypePages): post is WPPost<LocalInformationPostTypeACF> => {
        return post.type === "local-information";
    },
};

export const getPostType = (post: AllPostTypePages): PostTypes => {
    switch (post.type) {
        case "population":
            return PostTypes.Population;
        case "disorder-or-concern":
            return PostTypes.Condition;
        case "situations":
            return PostTypes.ChallengingSituation;
        case "local-information":
            return PostTypes.LocalInformation;
        default:
            throw new Error("Unknown post type");
    }
};

export const shouldShowLocalServices = (post: AllPostTypePages) => {
    if ("nswtb_process_local_services" in post.acf) {
        if (
            post.acf.nswtb_process_local_services === false 
        ) {
            return false;
        }
    }
    return PostTypesWithLocalServicesBeforeFooter.includes(getPostType(post));
};
